import {baseRequestService} from "../base.ts";
import {UserPatch} from "../../types/domain.ts";

export const usersUserIdPatch = (userId: number, data: UserPatch) => baseRequestService({
    url: `/users/${userId}`,
    method: 'PATCH',
    data
})